import React from 'react'
import Grid from '@material-ui/core/Grid';

// const useStyles = makeStyles((theme) => ({
//     root: {
//       flexGrow: 1,
//     },
//   }));
  
function DatasetSection() {

    //const classes = useStyles();  

    const styling = {
        backgroundColor: 'white',
        paddingBottom: '30px',
        // marginTop: '-60px',
        borderRadius: '4px',
        paddingLeft: '10px',
        paddingTop: '10px',
        width: '100%',
        // paddingRight: '150px',
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
        cursor: 'pointer',
        textDecoration: 'none'
    }

    return (
        <Grid container spacing = {5} style = {{marginTop: '-4rem'}}>
            <Grid item xs = {12} sm = {6}>
                <div style = {styling}>
                    <h3 style = {{color: 'black'}}>Datasets</h3>
                    <p  style = {{color: '#616161', marginTop: '-10px', paddingRight: '20px', textAlign: 'justify'}}>Data Sets will be released by Hackmakers and Oracle at 1900 AEST, Friday November 20. You are also welcome to use your own datasets.</p>
                </div>
            </Grid>
            <Grid item xs = {12} sm = {6}>
                <a rel="noopener noreferrer" target = "_blank" style = {styling} href = "//docs.google.com/document/d/1VMSHCGt7kF1ogwYSuZRVW2Cui9buPp_hQRKCdSxcgWw/edit">
                    <h3 style = {{textDecoration: 'none', color: 'black'}}>
                        Rules Guidelines &amp; FAQs
                    </h3>
                </a>
            </Grid>
        </Grid>

        //     <Grid 
    //         direction = "row" 
    //         container 
    //         className = {classes.root} 
    //         alignItems = "center" 
    //         spacing = {2}
    //     >
    //     <Grid item xs = {6} sm = {3} >
    //         <Grid container justify = "center" spacing = {2}>
    //             <Paper>
    //                 <h3>Datasets</h3>
    //                 <Typography paragraph color = "#616161">
    //                     You are free to use any open dataset
    //                 </Typography>
    //             </Paper>
    //         </Grid>
    //     </Grid>
    //     <Grid item xs = {12} sm = {3} >
    //         <Grid container justify = "center" spacing = {2}>
    //             <Paper>
    //                 <h3>Rules Guidelines and FAQs</h3>
    //                 <Typography paragraph>
    //                     You are free to use any open dataset
    //                 </Typography>
    //             </Paper>
    //         </Grid>
    //     </Grid>
    // </Grid>
    )
}

export default DatasetSection
